<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">3.</span>Your companies expected annual revenue:
              </label>        
              <input
                type="number"
                oninput="this.value=(parseInt(this.value)||0)"
                class="orep-text-input w-100"
                name="expectedAnnualRevenue"
                v-validate="'numeric'"
                @input="validateBeforeSubmit()"
                v-model="sipApplication.expectedAnnualRevenue"
              >
              <span
                  v-show="errors.has('expectedAnnualRevenue')"
                  class="help is-danger form-errors text-danger"
              >{{ errors.first('expectedAnnualRevenue') | filterText }}</span>

            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">4.</span> Request Limits of Liability:
              </label>
              <div class="row">
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="limitsOfLiability"
                        id="liability-one"
                        value="300K/600K"
                        class="orep-radio"
                        :checked="sipApplication.limitsOfLiability.find(liability => liability === '300K/600K')"
                        v-validate="'required|included:300K/600K,500K/1M,1M/3M,1M/5M,2M/2M,3M/3M,4M/4M,5M/5M'"
                        @change="validateBeforeSubmit() + limitsOfLiability($event)"
                      >
                      <span class="radio-span solo-checkbox-span">$300,000 / $600,000</span>
                    </label>
                  </div>                  
                </div>
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="limitsOfLiability"
                        id="liability-three"
                        value="500K/1M"
                        class="orep-radio"
                        :checked="sipApplication.limitsOfLiability.find(liability => liability === '500K/1M')"
                        @change="validateBeforeSubmit() + limitsOfLiability($event)"
                      >
                      <span class="radio-span solo-checkbox-span">$500,000 / $1,000,000</span>
                    </label>
                  </div>                  
                </div>
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="limitsOfLiability"
                        id="liability-five"
                        value="1M/3M"
                        class="orep-radio"
                        :checked="sipApplication.limitsOfLiability.find(liability => liability === '1M/3M')"
                        @change="validateBeforeSubmit() + limitsOfLiability($event)"
                      >
                      <span class="radio-span solo-checkbox-span">$1,000,000 / $3,000,000</span>
                    </label>
                  </div>                  
                </div>
                <span
                  v-show="errors.has('limitsOfLiability')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('limitsOfLiability') | filterText }}</span>
              </div>
            </article>
            <article>
              <label for class="form-heading title-section form-section flex">
                <h1 class="form-title">Desired Property Limits</h1>
              </label>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">5.</span> $25,000 of Business Personal Property Coverage (Furniture & Fixtures) is included in base policy at no extra cost
              </label>
              <!-- <div class="row">
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="personalPropertyCoverage"
                        id="property-coverage-one"
                        value="25K"
                        class="orep-radio"
                        :checked="true"
                        v-validate="'included:25K,50K,100K'"
                        @change="validateBeforeSubmit() + personalPropertyCoverage($event)"
                      >
                      <span class="radio-span solo-checkbox-span">$25,000 - Included - No Cost</span>
                    </label>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="personalPropertyCoverage"
                        id="property-coverage-two"
                        value="50K"
                        class="orep-radio"
                        :checked="sipApplication.personalPropertyCoverage.find(propertycoverage => propertycoverage === '50K')"
                        v-validate="'required|included:25K,50K,100K'"
                        @change="validateBeforeSubmit() + personalPropertyCoverage($event)"
                      >
                      <span class="radio-span solo-checkbox-span">$50,000</span>
                    </label>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="personalPropertyCoverage"
                        id="property-coverage-three"
                        value="100K"
                        class="orep-radio"
                        :checked="sipApplication.personalPropertyCoverage.find(propertycoverage => propertycoverage === '100K')"
                        v-validate="'required|included:25K,50K,100K'"
                        @change="validateBeforeSubmit() + personalPropertyCoverage($event)"
                      >
                      <span class="radio-span solo-checkbox-span">$100,000</span>
                    </label>
                  </div>
                </div>
                <span
                  v-show="errors.has('personalPropertyCoverage')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('personalPropertyCoverage') | filterText }}</span>
              </div> -->
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">6.</span> $25,000 of Business Income and Extra Expense is included in base policy at no extra cost
              </label>
              <!-- <div class="row">                 -->
                <!-- <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="businessIncomeAndExtraExpense"
                        value
                        disabled
                        class="orep-radio position-relative"
                        v-model="sipApplication.businessIncomeAndExtraExpense">
                      <span class="radio-span solo-checkbox-span">$25,000 - Included - No Cost</span>
                    </label>
                  </div>
                </div> -->
              <!-- </div> -->
            </article>
            <article>
              <label for class="form-heading title-section form-section flex">
                <h1 class="form-title">Underwriting</h1>
              </label>
            </article>
            <article class="input-section form-section">
              <div style="margin-top: 30px;margin-bottom: 10px;">
                <label for class="orep-label">
                  <span class="qtn mrpx-5">7.</span> Total number of Employees? (Inclusive of all investigators)
                </label>
                <input
                  type="text"
                  name="totalNumberOfEmployees"
                  v-model="sipApplication.totalNumberOfEmployees"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('totalNumberOfEmployees')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('totalNumberOfEmployees') | filterText }}</span>
              </div>
              <div class="row">
                <div class="col-md-4 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">a.</span> Number of Investigators?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <input
                      type="text"
                      name="numberOfInvestigators"
                      v-model="sipApplication.numberOfInvestigators"
                      class="orep-text-input"
                      v-validate="'required'"
                      @input="validateBeforeSubmit()"
                    >

                  </div>
                  <span
                    v-show="errors.has('numberOfInvestigators')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('numberOfInvestigators') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="col-md-9 item-wrapper">
                  <label for class="orep-label">
                    <span class="mr-1">8.</span>
                    Does the applicant subcontract any investigative work?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantSubcontract"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.doesApplicantSubcontract"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantSubcontract"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.doesApplicantSubcontract"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('doesApplicantSubcontract')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('doesApplicantSubcontract') | filterText }}</span>
                </div>

              </div>
              <div class="row"
                   v-if="sipApplication.doesApplicantSubcontract === 'true' || sipApplication.doesApplicantSubcontract == true"
              >
                <div class="col-md-9 col-sm-12">
                <label for class="orep-label">
                  <span class="qtn mrpx-5">a.</span> If Yes - What percentage of work is subcontracted?
                </label></div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                <input
                  type="text"
                  name="percentageOfWorkSubcontracted"
                  v-validate="'required'"
                  v-model="sipApplication.percentageOfWorkSubcontracted"
                  class="orep-text-input"
                  @input="validateBeforeSubmit()"
                >

              </div>
                  <span
                    v-show="errors.has('percentageOfWorkSubcontracted')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('percentageOfWorkSubcontracted') | filterText }}</span>
                </div>
              </div>
              <div class="row"
                   v-if="sipApplication.doesApplicantSubcontract === 'true' || sipApplication.doesApplicantSubcontract == true"
              >
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">b.</span>If Yes - Are subcontractors required to maintain their own liability coverage at a minimum limit of $300,000/$600,000?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="subcontractorsRequireToMaintainLiability"
                          v-validate="'required'"
                          value="true"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.subcontractorsRequireToMaintainLiability"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="subcontractorsRequireToMaintainLiability"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.subcontractorsRequireToMaintainLiability"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('subcontractorsRequireToMaintainLiability')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('subcontractorsRequireToMaintainLiability') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div style="margin-top: 30px;margin-bottom: 10px;">
                <label for class="orep-label">
                  <span class="qtn mrpx-5">9.</span> Annual Payroll (Prior 12 Months)
                </label>
                <input
                  type="text"
                  name="annualPayroll"
                  v-model="sipApplication.annualPayroll"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('annualPayroll')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('annualPayroll') | filterText }}</span>
              </div>
            </article>
            <article class="input-section form-section ten-wrapper">
              <div style="margin-top: 30px;margin-bottom: 10px;">
                <label for class="orep-label">
                  <span class="qtn mrpx-5">10.</span> How many years have you maintained continuous General Liability and Errors & Omissions Coverage?
                </label>
                <input
                  type="text"
                  name="yearsMaintainedContinuousGeneralLiability"
                  v-model="sipApplication.yearsMaintainedContinuousGeneralLiability"
                  class="orep-text-input w-100"
                  v-validate="'required'"
                  @input="validateBeforeSubmit()"
                >
                <span
                  v-show="errors.has('yearsMaintainedContinuousGeneralLiability')"
                  class="help is-danger form-errors text-danger"
                >{{ errors.first('yearsMaintainedContinuousGeneralLiability') | filterText }}</span>
              </div>
              <div class="row pb-3">
                <div class="col-md-6">
                  <label for class="input-info mb-3">
                    Name of Prior Insurance
                  </label>
                  <input
                    type="text"
                    name="nameOfPriorInsurance"
                    v-model="sipApplication.nameOfPriorInsurance"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-6">
                  <label for class="input-info mb-3">
                    Policy Period
                  </label>
                  <input
                    type="text"
                    name="policyPeriod"
                    v-model="sipApplication.policyPeriod"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                  >
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-6">
                  <label for class="input-info md-3">
                    Limit
                  </label>
                  <input
                    type="text"
                    name="maintainedLimit"
                    v-model="sipApplication.maintainedLimit"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-6">
                  <label for class="input-info md-3">
                    Deductible
                  </label>
                  <input
                      type="text"
                      name="maintainedDeductible"
                      v-model="sipApplication.maintainedDeductible"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                    >
                </div>                
              </div>  
              <div class="row pb-3">
                <div class="col-md-6">
                  <span for class="input-info">
                    Premium
                  </span>
                  <input
                    type="text"
                    name="maintainedPremium"
                    v-model="sipApplication.maintainedPremium"
                    class="orep-text-input w-100"
                    @input="validateBeforeSubmit()"
                  >
                </div>
              </div>                          
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="col-md-9 item-wrapper">
                  <label for class="orep-label">
                    <span class="mr-1">11.</span>
                    During the past five(5) years, has any claim been made or suit brought against the applicant?

                  </label>
                  <p>
                    (If Yes, please provide details on a separate attachment.)
                  </p>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="claimMadeInPast5Years"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.claimMadeInPast5Years"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="claimMadeInPast5Years"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.claimMadeInPast5Years"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('claimMadeInPast5Years')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('claimMadeInPast5Years') | filterText }}</span>
                </div>

              </div>

            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="col-md-9 item-wrapper">
                  <label for class="orep-label">
                    <span class="mr-1">12.</span>
                    Is the Applicant aware of any circumstance, allegation, contention, or incident which may result in a claim or
                    suit against the Applicant?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="applicantAwareOfAnyCircumstance"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.applicantAwareOfAnyCircumstance"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="applicantAwareOfAnyCircumstance"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.applicantAwareOfAnyCircumstance"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('applicantAwareOfAnyCircumstance')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('applicantAwareOfAnyCircumstance') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="col-md-9 item-wrapper">
                  <label for class="orep-label">
                    <span class="mr-1">13.</span>
                    Has any insurer canceled or refused to renew any similar insurance during the past five (5) years?
                  </label>
                  <p>(If Yes, please provide details on a separate attachment.)</p>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="insurerCanceledRefused5Years"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.insurerCanceledRefused5Years"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="insurerCanceledRefused5Years"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.insurerCanceledRefused5Years"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('insurerCanceledRefused5Years')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('insurerCanceledRefused5Years') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="flex wrap">
                <div class="col-md-9 item-wrapper">
                  <label for class="orep-label">
                    <span class="mr-1">14.</span>
                    Does any operation require you to carry and/or use of a firearm? (IF YOU CARRY FOR YOUR OWN PROTECTION, ANSWER NO)
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="useOfFirm"
                          value="true"
                          class="orep-radio"
                          v-validate="'required'"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.useOfFirm"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="useOfFirm"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.useOfFirm"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('useOfFirm')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('useOfFirm') | filterText }}</span>
                </div>
              </div>
            </article>
            <article>
              <label for class="form-heading title-section form-section flex">
                <h1 class="form-title"> Optional Coverages</h1>
              </label>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="qtn mrpx-5">15.</span> Hired and Non-Owned Auto:
              </label>
              <div class="radio orep-radio-wrapper solo-checkbox">
                <label>
                  <input
                    type="checkbox"
                    name="hireLimitLiability"
                    id="claim-limit-one"
                    value="50K/100K"
                    class="orep-radio"
                    :checked="sipApplication.hireLimitLiability.find(liability => liability === '50K/100K')"
                    v-validate="'included:50K/100K'"
                    @change="validateBeforeSubmit() + hireLimitLiability($event)"
                  >                     
                  <span class="radio-span solo-checkbox-span">$50,000/$100,000</span>
                </label>
              </div>
              <!-- <p>(Limit Selected cannot exceed primary liability limits)</p> -->
              <div class="flex wrap pb-3">
                <div class="col-md-9">
                  <label for class="input-info">
                    <span class="mr-1">a. Does the applicant have a commercial auto policy in place?</span>
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="commercialAutoPolicyInPlace"
                          value="true"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.commercialAutoPolicyInPlace"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="commercialAutoPolicyInPlace"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.commercialAutoPolicyInPlace"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex wrap pb-3">
                <div class="col-md-9">
                  <label for class="input-info">
                    <span class="mr-1">b. Does the applicant rent or hire auto in excess of 10 times per year?</span>
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantRentOrHireAuto10Time"
                          value="true"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.doesApplicantRentOrHireAuto10Time"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantRentOrHireAuto10Time"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.doesApplicantRentOrHireAuto10Time"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex wrap pb-3">
                <div class="col-md-9">
                  <label for class="input-info">
                    <span class="mr-1">c. Does the applicant use any auto to transport clients?</span>
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantUseAnyAuto"
                          value="true"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.doesApplicantUseAnyAuto"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantUseAnyAuto"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.doesApplicantUseAnyAuto"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex wrap pb-3">
                <div class="col-md-9">
                  <label for class="input-info">
                    <span class="mr-1">d. Does the applicant own any auto registered in the company's name or leased on a long term basis?</span>
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantOwnAnyAuto"
                          value="true"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.doesApplicantOwnAnyAuto"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doesApplicantOwnAnyAuto"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="sipApplication.doesApplicantOwnAnyAuto"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label for class="orep-label">
                      <span class="qtn mrpx-5">16.</span> Blanket Additional Insured:
                    </label>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="blanketAdditionalInsured"
                        value
                        disabled
                        class="orep-radio position-relative"
                        v-model="sipApplication.blanketAdditionalInsured">
                      <span class="radio-span solo-checkbox-span">Included - Included - No Cost</span>
                    </label>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label for class="orep-label">
                      <span class="qtn mrpx-5">17.</span> Private Eye Endorsement
                    </label>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="privateEyeEndorsement"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.privateEyeEndorsement"
                        disabled
                      >
                      <span class="radio-span solo-checkbox-span">Included - Included - No Cost</span>
                    </label>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label for class="orep-label">
                      <span class="qtn mrpx-5">18.</span> Waiver of Subrogation:
                    </label>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="waiverOfSubrogation"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.waiverOfSubrogation"
                        @change="validateBeforeSubmit()"
                      >
                      <span class="radio-span solo-checkbox-span">To Include  - Additional Cost $150</span>
                    </label>
                  </div>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label for class="orep-label">
                      <span class="qtn mrpx-5">19.</span> Primary Wording:
                    </label>
                  </div>
                </div>
                <div class="col-md-8">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="primaryWording"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.primaryWording"
                        @change="validateBeforeSubmit()"
                      >
                      <span class="radio-span solo-checkbox-span">To Include  - Additional Cost $150</span>
                    </label>
                  </div>
                </div>
              </div>
            </article>            
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-4">
                  <label for class="orep-label">
                    <span class="qtn mrpx-5">20.</span> Worldwide Coverage:
                  </label>
                </div>
                <div class="col-md-4">
                  <div class="radio orep-radio-wrapper solo-checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="worldwideCoverage"
                        value
                        class="orep-radio position-relative"
                        v-model="sipApplication.worldwideCoverage"
                        @change="validateBeforeSubmit()"
                      >
                      <span class="radio-span solo-checkbox-span">To Include  - Additional Cost</span>
                    </label>
                  </div>
                </div>
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-md-12">
        <section class="flex wrap bottom-section">
          <router-link :to="{name:'sip-application-1'}" class="next-btn back-btn flex mont spaced">
            <i class="fas fa-arrow-left"></i>
            Back
          </router-link>
          <article class="orep-pagination">
            <button @click="prev()" class="pagination-dots"></button>
            <button class="pagination-dots pagination-current"></button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid"
              @click="navigateToNext('sip-application-3')">
            </button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid ||!state.pageThreeIsValid "
              @click="navigateToNext('sip-application-4')">
            </button>
          </article>
          <button type="submit" :disabled="!state.pageTwoIsValid"
                  :class="{submitDisabled: !state.pageTwoIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('sip-application-3')">Next</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import Datepicker from 'vuejs-datepicker';
import {APP_STATUS, STATES, STATUS} from "../../utils/constants";


export default {
  name: "sip-application-2",
  computedDates() {
    return moment(this.value).format('YYYY-MM-D')
  },
  computed: {
    sipApplication() {
      return this.$store.state.sipApplication.sipApplication;
    },
    state() {
      return this.$store.state.sipApplication;
    },
    errorMsg() {
      return this.$store.state.sipApplication.errorMsg;
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000
          });
        }
      }
    }
  },
  methods: {
    expectedAnnualRevenue(event) {
      if(!this.sipApplication.expectedAnnualRevenue.find(revenue => revenue === event.target.value)) {
        if (this.sipApplication.expectedAnnualRevenue.length < 1) {
          this.sipApplication.expectedAnnualRevenue.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 1 option.'
          });
          event.target.checked = false
        }
      } else {
        this.sipApplication.expectedAnnualRevenue = this.sipApplication.expectedAnnualRevenue.filter(revenue => revenue !== event.target.value);
      }
    },
    personalPropertyCoverage(event) {
      if(!this.sipApplication.personalPropertyCoverage.find(propertycoverage => propertycoverage === event.target.value)) {
          this.sipApplication.personalPropertyCoverage.push(event.target.value);
      } else {
        this.sipApplication.personalPropertyCoverage = this.sipApplication.personalPropertyCoverage.filter(propertycoverage => propertycoverage !== event.target.value);
      }
    },
    limitsOfLiability(event) {
      if(!this.sipApplication.limitsOfLiability.find(liability => liability === event.target.value)) {
        if (this.sipApplication.limitsOfLiability.length < 1) {
          this.sipApplication.limitsOfLiability.push(event.target.value);
        } else {
          this.$notify({
            group: 'error',
            type: 'warning',
            title: 'Warning',
            text: 'You can select up to 1 option.'
          });
          event.target.checked = false
        }
      } else {
        this.sipApplication.limitsOfLiability = this.sipApplication.limitsOfLiability.filter(liability => liability !== event.target.value);
      }
    },
    hireLimitLiability(event) {
      if(!this.sipApplication.hireLimitLiability.find(liabilitylimit => liabilitylimit === event.target.value)) {
          this.sipApplication.hireLimitLiability.push(event.target.value);
      } else {
        this.sipApplication.hireLimitLiability = this.sipApplication.hireLimitLiability.filter(liabilitylimit => liabilitylimit !== event.target.value);
      }
    },
    prev() {
      this.$router.push({
        name: "sip-application-1"
      });
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.$validator.validateAll().then(result => {
        if (result) {
            this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = true;

      });
    },
  },

  mounted() {
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
table td, table th {
  border: 1px solid black;
}
table th {
  height: 35px;
}
table td:not(:first-child), table th:not(:first-child) {
  text-align: center;
  max-width: 140px;
}
table input {
  width: 100%;
  text-align: center;
}
</style>
